export const HEADERS = {
    openInvoices: ['createdOn', 'vinNumber', 'originPort', 'destinationPort', 'totalInvoiceAmountDue', 'statusId' ],
    inTransit: ['createdOn', 'vinNumber', 'originPort', 'destinationPort', 'carrier', 'status' ],
    onTerminal:  ['createdOn', 'vinNumber', 'originPort', 'destinationPort', 'carrier', 'status' ],
    booked: ['createdOn', 'vinNumber', 'originPort', 'destinationPort', 'carrier', 'status' ],
    vesselSchedule: ["carrierName", "vesselName", "originPort", "destinationPort", "loadingDate", "cutOffDate", "dischargeDate"]
}